import React from "react";
import {
  FiPlus,
  FiArrowUpRight,
  FiCalendar,
  FiUser,
  FiFileText,
  FiPackage,
  FiDollarSign,
} from "react-icons/fi";

export default function TransactionCard({ data }) {
  // Colors based on requirements
  const primaryColor = "#363062";
  const secondaryColor = "#8FCD00";

  return (
    <div className="w-full">
      <div className="flex justify-between items-start">
        <div>
          <span
            className="inline-flex items-center px-2 py-1 text-xs rounded-full"
            style={{
              backgroundColor:
                data.transactionType === "addition"
                  ? `${secondaryColor}20`
                  : `${primaryColor}20`,
              color:
                data.transactionType === "addition"
                  ? secondaryColor
                  : primaryColor,
            }}
          >
            {data.transactionType === "addition" ? (
              <FiPlus className="mr-1" size={12} />
            ) : (
              <FiArrowUpRight className="mr-1" size={12} />
            )}
            {data.transactionType === "addition" ? "Addition" : "Issuance"}
          </span>
          <h3 className="font-medium mt-2 flex items-center gap-1">
            <FiPackage className="text-gray-500" size={14} />
            {data.quantity} {data.quantity > 1 ? "units" : "unit"}
            {data.transactionType === "addition" ? " added" : " issued"}
            {data.transactionType === "issuance" && data.issuedTo
              ? ` to ${data.issuedTo}`
              : ""}
          </h3>
          {data.cost && (
            <p className="text-gray-600 text-sm flex items-center gap-1 mt-1">
              <FiDollarSign className="text-gray-500" size={12} />
              Unit Cost: ${data.cost}
            </p>
          )}
        </div>
        <div className="text-right">
          <p className="text-xs text-gray-500 flex items-center justify-end gap-1 mb-1">
            <FiCalendar size={12} />
            {data.date || data.createdAt}
          </p>
          <p className="text-xs flex items-center justify-end gap-1">
            <FiUser size={12} className="text-gray-500" />
            {data.user}
          </p>
        </div>
      </div>

      {(data.remarks || data.purpose) && (
        <div className="mt-3 pt-3 border-t border-gray-100">
          {data.purpose && (
            <p className="text-sm flex items-start gap-1 mb-1">
              <FiFileText size={12} className="text-gray-500 mt-1" />
              <span>
                <span className="font-medium">Purpose:</span> {data.purpose}
              </span>
            </p>
          )}
          {data.remarks && (
            <p className="text-sm flex items-start gap-1">
              <FiFileText size={12} className="text-gray-500 mt-1" />
              <span>
                <span className="font-medium">Remarks:</span> {data.remarks}
              </span>
            </p>
          )}
        </div>
      )}
    </div>
  );
}
